import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import { Grid } from 'react-styled-flexboxgrid'
import Flex from 'styled-flex-component'

import Loading from '@components/UI/Loading'
import {
  fetchSubmissionPerformance,
  selectIsFetchingSubmissionPerformance,
} from '@store/performance'
import { selectSubmissionId } from '@store/router'
import Theme from '@theme'
import { H3, Icon } from '@tribegroup'
import { ProfileDetailsWrapper, ProfileWrapper } from '../Influencer/Profile/Profile.styled'
import SubmissionPerformanceDetails from './Details/Details'
import { PerformanceIconWrapper } from './Performance.styled'

export const SubmissionPerformance: React.FC = () => {
  const match = useRouteMatch()
  const submissionId = selectSubmissionId(match) as number
  const isFetching = useSelector(selectIsFetchingSubmissionPerformance)
  const dispatch = useDispatch()

  React.useEffect(() => {
    dispatch(fetchSubmissionPerformance(submissionId))
  }, [submissionId])

  if (isFetching) {
    return <Loading />
  }

  return (
    <ProfileWrapper>
      <Flex alignCenter justifyBetween>
        <H3 color={Theme.grey900Color}>
          <FormattedMessage id="submission.performance.title" />
        </H3>
      </Flex>
      <ProfileDetailsWrapper>
        <PerformanceIconWrapper alignCenter justifyCenter>
          <Icon glyph="data" size={2} color={Theme.primaryColor} />
        </PerformanceIconWrapper>
      </ProfileDetailsWrapper>
      <Grid fluid>
        <SubmissionPerformanceDetails />
      </Grid>
    </ProfileWrapper>
  )
}

export default SubmissionPerformance
